import axios from "axios";

export const resolveBaseUrl = (): string => {
  const envUrl = process.env.REACT_APP_API_URL;

  if (typeof envUrl === "string" && envUrl.trim().length > 0) {
    return envUrl;
  }

  if (typeof window !== "undefined") {
    // When no explicit API URL is provided reuse the current origin.
    // CRA dev server will proxy requests (see package.json `proxy`).
    return window.location.origin;
  }

  return "http://localhost:3001";
};

const api = axios.create({
  baseURL: resolveBaseUrl(),
});

api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;
